
    /**
    * 所有的商品品牌
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid17409 {}
  /**
 * Response :Response
 */
export class IResid17409 {
  message?: {};
  code?: {};
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid17409, IResid17409 > = (data?) =>  request({
        method: 'GET',
        url: '/item/brand',
        params: data
      }) 
  export default http